import React from 'react';
import { motion } from 'framer-motion';
import { pageWrapperStyle } from '../../styles/pageStyles.js';
import './PolicyPage.css';

const CustomWorkTerms = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      style={{ ...pageWrapperStyle, backgroundColor: 'var(--alt-background)' }}
    >
      <section className="policy-page section">
        <div className="container">
          <div className="policy-content">
            <h1>Custom Work Terms and Conditions</h1>
            <p className="last-updated">Digital Fig Ltd</p>

            <h2>1. Scope of Services</h2>
            <p>Digital Fig provides custom development services including, but not limited to:</p>
            <ul>
              <li>Shopify plugins and apps</li>
              <li>Website enhancements</li>
              <li>Custom code or integrations</li>
              <li>Other bespoke digital solutions as agreed in writing</li>
            </ul>
            <p>Services will be delivered based on the client's specifications submitted prior to commencement. Digital Fig reserves the right to confirm feasibility and propose adjustments before starting work.</p>

            <h2>2. Pricing and Payment</h2>
            <ul>
              <li><strong>Rate:</strong> £40 per hour for all custom development work.</li>
              <li><strong>Estimates:</strong> Any estimated cost or time provided is indicative. Final charges will be based on actual hours worked.</li>
              <li><strong>Payment Terms:</strong>
                <ul>
                  <li>Invoices will be issued weekly or upon project milestones, as agreed.</li>
                  <li>Payment is due within 14 days of invoice date.</li>
                </ul>
              </li>
            </ul>

            <h2>3. Project Commencement</h2>
            <ul>
              <li>Work will commence once the client has provided all necessary materials and agreed on project specifications.</li>
              <li>Digital Fig reserves the right to delay start dates if required information is not provided in a timely manner.</li>
            </ul>

            <h2>4. Client Responsibilities</h2>
            <p>The client agrees to:</p>
            <ul>
              <li>Provide accurate project specifications and all necessary materials.</li>
              <li>Respond promptly to queries or feedback to avoid delays.</li>
              <li>Ensure they have the rights or licences for any third-party content supplied.</li>
            </ul>

            <h2>5. Ownership and Intellectual Property</h2>
            <ul>
              <li>Upon full payment, the client will own the final deliverables created specifically for them.</li>
              <li>Digital Fig retains the right to showcase work in portfolios, marketing, or case studies, unless otherwise agreed in writing.</li>
              <li>Third-party libraries, plugins, or tools used remain under their respective licences.</li>
            </ul>

            <h2>6. Revisions</h2>
            <ul>
              <li>Minor revisions (clarifications or bug fixes) are included in the quoted hours.</li>
              <li>Major changes or additional features requested after work has started will be charged at £40/hour.</li>
            </ul>

            <h2>7. Warranty and Liability</h2>
            <ul>
              <li>Digital Fig will ensure work is delivered to a professional standard.</li>
              <li>No liability is accepted for:
                <ul>
                  <li>Loss of data</li>
                  <li>Compatibility issues caused by future platform updates</li>
                  <li>Third-party service failures</li>
                </ul>
              </li>
              <li>Maximum liability is limited to the amount paid for the custom work.</li>
            </ul>

            <h2>8. Termination</h2>
            <ul>
              <li>Either party may terminate the project in writing.</li>
              <li>In the event of termination:
                <ul>
                  <li>The client will pay for all hours worked up to the termination date.</li>
                  <li>Deliverables completed to date will be supplied upon full payment.</li>
                </ul>
              </li>
            </ul>

            <h2>9. Governing Law</h2>
            <ul>
              <li>These Terms and Conditions are governed by the laws of England and Wales.</li>
              <li>Any disputes will be resolved in the courts of England and Wales.</li>
            </ul>

            <h2>10. Acceptance</h2>
            <p>By engaging Digital Fig for custom work, the client agrees to these Terms and Conditions in full.</p>
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default CustomWorkTerms;
